<template>
  <section class="save-comparison-component">
    <modal-center
      ref="saveComparisonModal"
      class="save-comparison-modal-container"
      name="save-comparison"
    >
      <template #hook>
        <slot name="modal-toggle" />
        <slot name="confirmation" />
      </template>
      <template #content>
        <slot name="modal" />
      </template>
    </modal-center>
  </section>
</template>
<script>
import ModalCenter from '../../elements/modal/center/modalCenter.vue';

export default {
    name: 'SaveComparison',
    components: {
        ModalCenter,
    },

};
</script>
